import React from "react";
import Polygon from "../../assets/Career/Polygon 28 (1).svg";
import EllipsePenta from "../../assets/Career/Ellipse-penta .png";
import Vector from "../../assets/Career/Vector 2812.svg";
import IconFlag from "../../assets/Career/material-symbols_flag (1).svg";
import IconLink from "../../assets/Career/ic_round-link (1).svg";
import Icon2 from "../../assets/Career/Icon 2.svg";
import IconBackground from "../../assets/Career/career-background.svg";
import Icon1 from "../../assets/Career/icon 1.svg";
import Icon3 from "../../assets/Career/icon 3.svg";
import TagButton from "../common/TagButton";
import { div } from "framer-motion/client";

const Boot41Flow = () => (
  <div className="flex flex-col gap-[64px] pt-[36px] md:pt-0">
    <div className="px-[20px] md:px-0">
      <TagButton text="Boot41 Journey" />
    </div>
    <section className="bg-white relative flex justify-center items-start md:mt-[64px] w-full">
      {/* Desktop SVG Line + Icons */}
      <div className="absolute w-[1107px] h-[172px] top-[150px] left-0 hidden md:block">
        <svg
          width="1107"
          height="172"
          viewBox="0 0 1107 172"
          fill="none"
          className="absolute top-0 left-0"
        >
          <path
            opacity="0.5"
            d="M1 133.524C53.8573 169.871 203.592 211.125 379.671 85.3645C555.751 -40.3961 632.75 -8.64742 767.847 70.8425C853.838 121.439 1014.96 151.261 1106 44.0198"
            stroke="#F1F1F1"
            strokeWidth="2"
          />
        </svg>
        <svg
          width="1107"
          height="172"
          viewBox="0 0 1107 172"
          fill="none"
          className="absolute top-0 left-0"
        >
          <path
            d="M1 133.524C53.8573 169.871 203.592 211.125 379.671 85.3645C555.751 -40.3961 632.75 -8.64742 767.847 70.8425C853.838 121.439 1014.96 151.261 1106 44.0198"
            stroke="#23619A"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg>
        <span
          className="absolute left-[100px] top-[120px] flex items-center justify-center"
          style={{ width: "120px", height: "120px", flexShrink: 0 }}
        >
          <img
            src={Icon1}
            alt="icon1"
            style={{ width: "120px", height: "120px", flexShrink: 0 }}
          />
        </span>
        <span
          className="absolute left-[521px] top-[-49px] flex items-center justify-center"
          style={{ width: "120px", height: "120px", flexShrink: 0 }}
        >
          <img
            src={Icon2}
            alt="icon2"
            style={{ width: "120px", height: "120px", flexShrink: 0 }}
          />
        </span>
        <span
          className="absolute right-[100px] top-[65px] flex items-center justify-center"
          style={{ width: "120px", height: "120px", flexShrink: 0 }}
        >
          <img
            src={Icon3}
            alt="icon3"
            style={{ width: "120px", height: "120px", flexShrink: 0 }}
          />
        </span>
      </div>

      {/* Desktop Layout */}
      <div className="pl-[34px] w-full max-w-[1440px] h-[496px] relative hidden md:block">
        <span
          className="absolute left-[205px] top-[-98px] font-['Roboto'] text-[122.093px] font-semibold bg-gradient-to-b from-[#D6D7DB] to-[#FFFFFF] bg-clip-text text-transparent z-0 pointer-events-none h-fit w-fit select-none"
          style={{
            WebkitMaskImage:
              "linear-gradient(to bottom, black 60%, transparent 100%)",
            maskImage:
              "linear-gradient(to bottom, black 60%, transparent 100%)",
            opacity: 0.9,
            pointerEvents: "none",
            userSelect: "none",
          }}
        >
          1
        </span>
        <span
          className="absolute left-[630px] top-[230px] font-['Roboto'] text-[122.093px] font-semibold bg-gradient-to-b from-[#D6D7DB] to-[#FFFFFF] bg-clip-text text-transparent z-0 pointer-events-none h-fit w-fit select-none"
          style={{
            WebkitMaskImage:
              "linear-gradient(to bottom, black 60%, transparent 100%)",
            maskImage:
              "linear-gradient(to bottom, black 60%, transparent 100%)",
            opacity: 0.9,
            pointerEvents: "none",
            userSelect: "none",
          }}
        >
          2
        </span>
        <span
          className="absolute right-0 left-[1135px] top-[-90px] font-['Roboto'] text-[122.093px] font-semibold bg-gradient-to-b from-[#D6D7DB] to-[#FFFFFF] bg-clip-text text-transparent z-0 pointer-events-none h-fit w-fit select-none"
          style={{
            position: "absolute",
            WebkitMaskImage:
              "linear-gradient(to bottom, black 60%, transparent 100%)",
            maskImage:
              "linear-gradient(to bottom, black 60%, transparent 100%)",
            opacity: 0.9,
            pointerEvents: "none",
            userSelect: "none",
          }}
        >
          3
        </span>

        <div className="absolute left-0 top-[8px] w-[406px] z-[2] text-left">
          <div className="text-[#23619A] font-['Montserrat']  text-[24px] font-bold mb-[15px]">
            Foundation Track
          </div>
          <div className="text-[#4D4D4D] font-['roboto'] font-light text-[15.852px]  leading-[24.659px] text-justify">
            Covers core technical skills in Java, Python, and React. Includes
            structured assessments and personalized learning paths to strengthen
            problem-solving, logic, and code quality.
          </div>
        </div>

        <div className="absolute left-[356px] top-[332px] w-[406px] z-[2] text-left">
          <div className="text-[#23619A] font-['Montserrat'] text-[24px] font-bold mb-[15px]">
            GenAI Mini-App Sprint
          </div>
          <div className="text-[#4D4D4D] font-['roboto'] font-light text-[15.852px] leading-[24.659px] text-justify">
            Participants build functional mini applications using Generative AI
            tools and frameworks. Each sprint spans one week—focused on solving
            specific real-world problems through individual projects.
          </div>
        </div>

        <div className="absolute right-0 top-[8px] w-[406px] z-[2] text-left">
          <div className="text-[#23619A] font-['Montserrat']  text-[24px] font-bold mb-[15px]">
            Collaborative Project Phase
          </div>
          <div className="text-[#4D4D4D] font-['roboto'] font-light text-[15.852px]  leading-[24.659px] text-justify">
            Final teams are formed to work on larger AI-driven solutions. This
            phase emphasizes collaboration, architecture design, and delivery
            ownership—mirroring real engineering team dynamics.
          </div>
        </div>
      </div>

      {/* Updated Mobile Layout */}
      <div className="md:hidden w-full flex flex-col pb-16 relative gap-[64px]">
        {/* Step 1 */}
        <div className="relative bg-white flex flex-col px-[20px] md:px-0">
          <span
            className="absolute text-[100px] font-bold text-gray-300 right-[30px] opacity-40 -z-0 select-none leading-none top-[-10px]"
            style={{
              WebkitMaskImage:
                "linear-gradient(to bottom, black 60%, transparent 100%)",
              maskImage:
                "linear-gradient(to bottom, black 60%, transparent 100%)",
              opacity: 0.45,
              pointerEvents: "none",
              userSelect: "none",
            }}
          >
            1
          </span>
          <img
            src={Icon1}
            alt="icon1"
            className="w-[90px] h-[90px] z-10 mb-[10px]"
          />
          <h3 className="text-[#23619A] text-[20px] font-bold z-10">
            Foundation Track
          </h3>
          <p className="text-[#4D4D4D] text-[15px] leading-[24px] z-10 mt-2 ">
            Covers core technical skills in Java, Python, and React. Includes
            structured assessments and personalized learning paths to strengthen
            problem-solving, logic, and code quality.
          </p>
        </div>

        {/* Step 2 */}
        <div className="relative bg-white flex flex-col px-[20px] md:px-0">
          <span
            className="absolute text-[100px] font-bold text-gray-300 right-[30px] opacity-40 -z-0 select-none leading-none top-[-10px]"
            style={{
              WebkitMaskImage:
                "linear-gradient(to bottom, black 60%, transparent 100%)",
              maskImage:
                "linear-gradient(to bottom, black 60%, transparent 100%)",
              opacity: 0.45,
              pointerEvents: "none",
              userSelect: "none",
            }}
          >
            2
          </span>
          <img
            src={Icon2}
            alt="icon2"
            className="w-[90px] h-[90px] z-10 mb-[10px]"
          />
          <h3 className="text-[#23619A] text-[20px] font-bold z-10">
            GenAI Mini-App Sprint
          </h3>
          <p className="text-[#4D4D4D] text-[15px] leading-[24px] z-10 mt-2">
            Participants build functional mini applications using Generative AI
            tools and frameworks. Each sprint spans one week—focused on solving
            specific real-world problems through individual projects.
          </p>
        </div>

        {/* Step 3 */}
        <div className="relative bg-white flex flex-col px-[20px] md:px-0">
          <span
            className="absolute text-[100px] font-bold text-gray-300 right-[30px] opacity-40 -z-0 select-none leading-none top-[-10px]"
            style={{
              WebkitMaskImage:
                "linear-gradient(to bottom, black 60%, transparent 100%)",
              maskImage:
                "linear-gradient(to bottom, black 60%, transparent 100%)",
              opacity: 0.45,
              pointerEvents: "none",
              userSelect: "none",
            }}
          >
            3
          </span>
          <img
            src={Icon3}
            alt="icon3"
            className="w-[90px] h-[90px] z-10 mb-[10px]"
          />
          <h3 className="text-[#23619A] text-[20px] font-bold z-10">
            Collaborative Project Phase
          </h3>
          <p className="text-[#4D4D4D] text-[15px] leading-[24px] z-10 mt-2">
            Final teams are formed to work on larger AI-driven solutions. This
            phase emphasizes collaboration, architecture design, and delivery
            ownership—mirroring real engineering team dynamics.
          </p>
        </div>
      </div>
    </section>
  </div>
);

export default Boot41Flow;
